import type { BetterstartCommandRuntime } from '@core-engine/commands/runtime.js'
import { runAddCommand } from './commands/add.js'
import { runAddFieldCommand } from './commands/add-field.js'
import { runGenerateCommand } from './commands/generate.js'
import { runInitCommand } from './commands/init.js'
import { runListIntegrationsCommand } from './commands/list-integrations.js'
import { runListPluginsCommand } from './commands/list-plugins.js'
import { runRemoveCommand } from './commands/remove.js'
import { runRemoveSchemaCommand } from './commands/remove-schema.js'
import { runSeedCommand } from './commands/seed.js'
import { runUninstallCommand } from './commands/uninstall.js'
import { runUpdateCommand } from './commands/update-component.js'
import { runUpdateDepsCommand } from './commands/update-deps.js'
import { runUpdateStylesCommand } from './commands/update-styles.js'

export const nextCommandRuntime: BetterstartCommandRuntime = {
  runAdd: runAddCommand,
  runAddField: runAddFieldCommand,
  runGenerate: runGenerateCommand,
  runInit: runInitCommand,
  runListIntegrations: runListIntegrationsCommand,
  runListPlugins: runListPluginsCommand,
  runRemove: runRemoveCommand,
  runRemoveSchema: runRemoveSchemaCommand,
  runSeed: runSeedCommand,
  runUninstall: runUninstallCommand,
  runUpdate: runUpdateCommand,
  runUpdateDeps: runUpdateDepsCommand,
  runUpdateStyles: runUpdateStylesCommand
}
